import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import theme from "Theme/AppTheme";

import {
    sanitizeHtml,
    sanitizeQuestionTableHtml,
} from "utils/sanitizeHtml";
import { AcxExpandableText } from "./AcxExpandableText";
import AcxDialog from "./Dialog/AcxDialog";

interface AcxQuestionDescriptionProps {
    text: string;
    /**
     * If this is true, table descriptions will be displayed in a modal, text descriptions are not effected.
     */
    isModalForTablesVariant?: boolean;
}

const AcxQuestionDescription = (props: AcxQuestionDescriptionProps) => {
    const hasValidDescription = !!sanitizeHtml(props.text);
    const [showDescription, setShowDescription] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const isTable = props.text?.includes("</table>");

    if (!hasValidDescription) return null;

    const collapseExpandButton = (
        <Typography
            component={"div"}
            onClick={() => setShowDescription((prev) => !prev)}
            paddingTop={theme.spacing(0.5)}
            style={{
                cursor: "pointer",
                color: theme.palette.primary.main,
            }}
        >
            {showDescription ? "Show Less" : "Show More"}
        </Typography>
    );

    const tableDescription = (
        <>
            {/* Legacy descriptions can have html table elements that need to be supported */}
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
                paddingLeft={theme.spacing(1)}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: sanitizeQuestionTableHtml(props.text),
                    }}
                    style={{
                        overflow: showDescription ? "auto" : "hidden",
                        maxHeight: showDescription ? "none" : "0px",
                    }}
                />
            </Grid>

            {props.text.length > 250 && collapseExpandButton}
        </>
    );

    return (
        <>
            <Grid
                item
                paddingBottom={theme.spacing(1)}
                paddingTop={theme.spacing(1)}
            >
                {isTable ? (
                    props.isModalForTablesVariant ? (
                        <Typography
                            component={"div"}
                            onClick={() => setShowModal((prev) => !prev)}
                            paddingTop={theme.spacing(0.5)}
                            style={{
                                cursor: "pointer",
                                color: theme.palette.primary.main,
                            }}
                        >
                            {"Show More"}
                        </Typography>
                    ) : (
                        tableDescription
                    )
                ) : (
                    <AcxExpandableText>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(props.text),
                            }}
                        />
                    </AcxExpandableText>
                )}
            </Grid>
            {isTable && props.isModalForTablesVariant && (
                <AcxDialog
                    isOpen={showModal}
                    onClose={() => {
                        setShowModal((prev) => !prev);
                    }}
                    title="Description"
                    dialogContentChildren={
                        <div
                            dangerouslySetInnerHTML={{
                                __html: sanitizeQuestionTableHtml(props.text),
                            }}
                        />
                    }
                />
            )}
        </>
    );
};

export default AcxQuestionDescription;
